"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminTicketListItemDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
const AdminVenueEvent_dto_1 = require("./AdminVenueEvent.dto");
class AdminTicketListItemDto {}
exports.AdminTicketListItemDto = AdminTicketListItemDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminTicketListItemDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminVenueEvent_dto_1.AdminVenueEventUserDto
}), __metadata("design:type", AdminVenueEvent_dto_1.AdminVenueEventUserDto)], AdminTicketListItemDto.prototype, "user", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminVenueEvent_dto_1.AdminVenueEventSummaryDto
}), __metadata("design:type", AdminVenueEvent_dto_1.AdminVenueEventSummaryDto)], AdminTicketListItemDto.prototype, "event", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminVenueEvent_dto_1.AdminVenueEventVenueDto,
  description: 'Venue hosting the event.'
}), __metadata("design:type", AdminVenueEvent_dto_1.AdminVenueEventVenueDto)], AdminTicketListItemDto.prototype, "venue", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], AdminTicketListItemDto.prototype, "eventStartDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Unit price in cents (USD).'
}), __metadata("design:type", Number)], AdminTicketListItemDto.prototype, "priceCents", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminTicketListItemDto.prototype, "quantity", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Amount charged in cents (USD).'
}), __metadata("design:type", Number)], AdminTicketListItemDto.prototype, "totalCents", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.TicketStatus
}), __metadata("design:type", String)], AdminTicketListItemDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Square payment ID — look it up in the Square Dashboard.'
}), __metadata("design:type", Object)], AdminTicketListItemDto.prototype, "squarePaymentId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminTicketListItemDto.prototype, "purchasedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.EventSource,
  nullable: true,
  description: 'Where the user opened the event from; null for older app builds.'
}), __metadata("design:type", Object)], AdminTicketListItemDto.prototype, "source", void 0);
//# sourceMappingURL=AdminTicket.dto.js.map